'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var copyToClipboard = function copyToClipboard(value) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return null;
  };

  var tempTextArea = document.createElement('textarea');
  tempTextArea.style.cssText = 'position: absolute; left: -1000px; top: -1000px';
  tempTextArea.value = value;
  document.body.appendChild(tempTextArea);
  tempTextArea.select();
  var isSuccessful = document.execCommand('copy');
  document.body.removeChild(tempTextArea);

  callback(isSuccessful);
};

exports.default = copyToClipboard;